import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { head } from '@/router/Head';

const accountsSearchSchema = z.object({
  /**
   * Optional search query for filtering accounts by name or other attributes.
   */
  filter: z.enum(['owner', 'member']).optional(),
});

export const Route = createFileRoute('/_authenticated/_dashboard/accounts/')({
  validateSearch: accountsSearchSchema,
  staticData: {
    title: 'Accounts',
    domain: 'account',
  },
  head,
  component: lazyRouteComponent(() => import('./index.component'), 'AccountsComponent'),
});
